'use client';

import usePopulatedContext from '@/hooks/usePopulatedContext';
import UserContext from './UserContext';

export const useUser = () => usePopulatedContext(UserContext).user;
